import { DISTANCE_VENDOR_PICKUP } from '@shopDetails/model';
import getPropFromModule from './getPropFromModule';

const getDistanceVendor = state =>
  getPropFromModule(state, DISTANCE_VENDOR_PICKUP) || {};

export default getDistanceVendor;
